import { format } from 'date-fns';

export const formatDate = (dateString: string, dateFormat = 'MM/dd/yyyy'): string => {
    const date = new Date(dateString);

    const dateOnly = new Date(date.valueOf() + date.getTimezoneOffset() * 60 * 1000);

    return format(dateOnly, dateFormat);
};
